import { Request } from "@xt/xtbase";
const { XtAxios4 } = Request;

const URL = "/uaapi/uaa/";

// passkey begin
export function post_passkeyAuthenticateBegin(config?) {
  return XtAxios4.post(URL + `authorize/passkey/authenticate-begin`, null, config);
}
// passkey finish
export function post_passkeyAuthenticateFinish(config?) {
  return XtAxios4.post(URL + `authorize/passkey/authenticate-finish`, null, config);
}

//多因子登录时，二次验证发送验证码
export function get_tokenSendCode(config?) {
  return XtAxios4.get(URL + `authorize/token/send-code`, config);
}
